import { usePeerNavigationReceiver } from "./usePeerNavigationReceiver";

/**
 * Single mount point for the cross-app navigation receiver (Galileo -> Einstein).
 *
 * The bridge calls `usePeerNavigationReceiver` once for the whole authenticated
 * app surface and renders nothing. Mounting here — inside `<RealtimeProvider>`
 * and with router context, as a sibling of `<Routes>` — means the intent handler
 * survives route transitions and the installed PWA designates itself exactly once
 * per session. It is named for its role (a transport-to-navigation reconciler)
 * rather than the hook it wraps, so it lands as a sibling of the other realtime
 * bridges (`QueueRealtimeBridge`, `PresenceChannelBridge`, …) instead of accreting
 * onto a generic grab-bag.
 *
 * Invariant: render this component exactly once. The hook attaches a SignalR
 * `PeerNavigateIntent` handler per mount; a duplicate mount would act on the same
 * intent twice on the designated tab.
 */
export function PeerNavigationReceiverBridge(): null {
    usePeerNavigationReceiver();
    return null;
}
